export type EngagementBadgeId =
  | 'firstKick' | 'rookie' | 'regular' | 'weekly' | 'biweekly' | 'monthly';

export interface EngagementBadgeMeta {
  readonly id: EngagementBadgeId;
  readonly threshold: number;
  readonly emoji: string;
  readonly i18nKey: string;
}

// IMPORTANT (Plan #6 §4.3): thresholds are an immutable contract after launch.
// Changing them silently revokes/grants badges for existing users (no schema for
// historical earned-state). To add a new tier, append a NEW id+threshold; never
// renumber an existing tier.
export const ENGAGEMENT_BADGES: readonly EngagementBadgeMeta[] = [
  { id: 'firstKick', threshold: 1,  emoji: '🥚', i18nKey: 'engagementBadge.firstKick' },
  { id: 'rookie',    threshold: 2,  emoji: '🐣', i18nKey: 'engagementBadge.rookie' },
  { id: 'regular',   threshold: 3,  emoji: '🔥', i18nKey: 'engagementBadge.regular' },
  { id: 'weekly',    threshold: 7,  emoji: '⭐', i18nKey: 'engagementBadge.weekly' },
  { id: 'biweekly',  threshold: 14, emoji: '🌟', i18nKey: 'engagementBadge.biweekly' },
  { id: 'monthly',   threshold: 30, emoji: '🏅', i18nKey: 'engagementBadge.monthly' },
];

export function unlockedEngagementBadges(longest: number): EngagementBadgeId[] {
  return ENGAGEMENT_BADGES
    .filter((b) => longest >= b.threshold)
    .map((b) => b.id);
}

/** Returns the largest engagement-tier threshold ≤ longest, or 0 if none reached. */
export function lastEarnedThreshold(longest: number): number {
  let max = 0;
  for (const b of ENGAGEMENT_BADGES) {
    if (longest >= b.threshold && b.threshold > max) max = b.threshold;
  }
  return max;
}
